import { PATH_TO_LOGIN, PATH_TO_INDEX } from '@/constants';
import { message, Modal } from 'antd';
import apis from '@/apis';
// 登录类型
enum loginType {
  erp = 1,
  jd = 2,
}

// 内网登录
const erpLogin = {
  login(href: string) {
    window.location.href = `//ssa.jd.com/sso/login?ReturnUrl=${encodeURIComponent(href || PATH_TO_INDEX)}`;
  },
};

// 外网登录
const jdLogin = {
  login(href: string) {
    window.location.href = `//passport.jd.com/new/login.aspx?ReturnUrl=${encodeURIComponent(href || PATH_TO_INDEX)}`;
  },
};

/**
 * 退出登录，需要询问服务端登录类型是erp登录还是外网登录
 */
let toLogout = async () => {
  try {
    const res = await apis.logout();

    if (res.ret !== '0') return message.error('退出登录失败，请稍后重试');

    // 退出登录成功后直接跳转登录页面
    window.location.href = PATH_TO_LOGIN;
  } catch (ex) {
    console.error('退出登录失败', ex);
    message.error('退出登录失败，请稍后重试');
  }
};

/**
 * 跳转sso登录
 *
 * @param href 登录成功之后回跳地址
 * @param useingType 使用的登录类型
 */
function toLogin(href: string, useingType: loginType) {
  switch (useingType) {
    case loginType.erp:
      erpLogin.login(href);
      break;
    case loginType.jd:
      jdLogin.login(href);
      break;
    default:
      erpLogin.login(href);
      break;
  }
}

// 为了通天塔内嵌页面服务
// 获取退出登录的href
function getLogoutHref() {
  return PATH_TO_LOGIN;
  // TOFIX: 外网无法使用内网退出登录，所以退出动作直接跳转营销中心登录页，不做实质退出
  // 后期完善外网退出登录后再修改
  // return 'https://ssa.jd.com/sso/logout?ReturnUrl=' + encodeURIComponent(getLoginPath());
}

/**
 * 登录态失效，跳转活动中心登录
 * 登录态过期登录后回到登录态失效页面
 */
function loginStateExpiress() {
  window.location.href = `/login.html?ReturnUrl=${encodeURIComponent(location.href)}`;
}

// 外网账号未关联内网账号导致登录异常
function afterLoginFailed() {
  Modal.warning({
    style: { top: 180 },
    content: '您使用的京东账号未与内部员工ERP绑定，无法登陆',
    okText: '重新登录',
    cancelText: null,
    onOk: loginStateExpiress,
  });
}

export { toLogout, loginStateExpiress, getLogoutHref, loginType, afterLoginFailed };

export default toLogin;
